import { ApiResponse } from "../../apiResponse";
import Axios from "../../axios";

export function indexSessionStatus(
  token: string | number
): Promise<ApiResponse> {
  return Axios.get(`v1/learners/sessions/in_progress`, {
    params: {
      learner_token: token,
    },
  });
}
